import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 440px;
`;

export const WrapperInputFile = styled.div``;
export const DropPlusIcon = styled.img`
  cursor: pointer;
`;
export const DragDrop = styled.div`
  border-radius: 4px;
  /* border: 1px dashed #bbc2d1; */
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='14' ry='14' stroke='black' stroke-width='1' stroke-dasharray='20' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 14px;
  border-radius: 16px;
  border-radius: 20px;
  border-radius: 6px;
  border-radius: 10px;
  border-radius: 12px;
  display: flex;
  gap: 0 8px;
  align-items: center;
  justify-content: center;
  padding: 20px 50px;

  > p {
    color: #111;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5rem;

    > span {
      font-weight: 600;
    }
  }
`;
